module.exports = {
	"cognito": {
		"poolId": "us-east-1:f3383568-a45b-4b65-9a93-d8a4dc582c76"
	},
	"lex": {
		"botName": "DHL",
		"initialText": "Welcome to DHL. Just type \"Tracking or Shipping or Get Quote\" or click on the mic and say it.",
		"initialSpeechInstruction": "Say 'Tracking or Shipping or Get Quote' to get started."
	},
	"ui": {
		"parentOrigin": "https://dhl-pipeline-1oylq1kfcgpix-parentpagebucket-kpjlmwcjsmlo.s3.amazonaws.com",
		"pageTitle": "DHL Bot",
		"toolbarTitle": "DHL"
	},
	"polly": {
		"voiceId": "Salli"
	},
	"recorder": {
		"preset": "speech_recognition"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.prod.json
// module id = 430
// module chunks = 1